module.exports = __webpack_public_path__ + "img/MORANGO-NA-COLHER.c0df09ea.jpg";